import { ItemStatus } from '@/types/item';

const itemStatuses: ItemStatus[] = ['closed', 'in_progress', 'open', 'snoozed'];

export default itemStatuses;
